function openCustomModal(name, callback) {
    try {
        // apply callback
        const confirmBtn = document.querySelector("#customPopupConfirmButton");
        if (confirmBtn && typeof callback === "function") {
            // clone node to remove previous listeners
            confirmBtn.replaceWith(confirmBtn.cloneNode(true));
            const newButton = document.querySelector("#customPopupConfirmButton");
            newButton.addEventListener("click", callback);
        }

        // disable body scrolling
        document.querySelector("body").classList.add("custom-popup-open");

        // re-render body to apply html
        const popup = document.querySelector(`#${name}`);
        popup.querySelectorAll("p").forEach(p => {
            const hasEscapedTags = p.innerHTML.includes("&lt;") || p.innerHTML.includes("&gt;");
            
            if (hasEscapedTags) {
                const decoded = new DOMParser().parseFromString(p.innerHTML, "text/html").body.textContent;
                p.innerHTML = decoded;
            }
        });

        // show popup
        document.querySelector(`#${name}`).classList.remove("hidden");
    }
    catch (e) {
        document.querySelector("body").classList.remove("custom-popup-open");
    }
}

function closeCustomModal(name) {
    // enable body scrolling
    document.querySelector("body").classList.remove("custom-popup-open");

    // hide popup
    document.querySelector(`#${name}`).classList.add("hidden");
}

///////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////

